import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/app/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/app/web/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { ArrowRightOutlined, CloseOutlined } from '@ant-design/icons';
import { Alert, Button, List, Modal, Progress, Result, Tooltip } from 'antd';
import { TaskStateColor, TaskStateColorDark } from 'core/interfaces/variables.types';
import { TaskState } from 'core/modules/tasks/task.interface';
import { taskCanChangeState } from 'core/modules/tasks/task.service';
import { getTaskStore } from 'core/modules/tasks/task.store';
import { mapReducer } from 'core/utils/store';
import { useEffect, useMemo, useReducer, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { TaskReferenceView } from 'src/components/Tasks/Reference';
import { TaskStateIcon } from 'src/types/task.types';
import { classes } from 'src/utils/classes';
import styled, { css } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TasksChangeStateModal = function TasksChangeStateModal(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getTaskStore = getTaskStore(),
      updateTaskState = _getTaskStore.updateTaskState;

  var _useState = useState([]),
      tasks = _useState[0],
      setTasks = _useState[1];

  var _useState2 = useState(false),
      isDeleting = _useState2[0],
      setDeleting = _useState2[1];

  var _useReducer = useReducer(mapReducer, {}),
      statuses = _useReducer[0],
      dispatchStatus = _useReducer[1];

  var itemsToProcess = useMemo(function () {
    var result = [];

    var _iterator = _createForOfIteratorHelper(tasks),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _statuses$item$id, _statuses$item$id2;

        var item = _step.value;

        if (item.canChangeState && (!((_statuses$item$id = statuses[item.id]) !== null && _statuses$item$id !== void 0 && _statuses$item$id.active) || (_statuses$item$id2 = statuses[item.id]) !== null && _statuses$item$id2 !== void 0 && _statuses$item$id2.error)) {
          result.push(item);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return result;
  }, [tasks, statuses]);
  var hasTasksThatCantChange = useMemo(function () {
    return tasks.some(function (task) {
      return !task.canChangeState;
    });
  }, [tasks]);
  var hasFinished = useMemo(function () {
    return !Object.values(statuses).some(function (status) {
      return !status.finished;
    });
  }, [statuses]);
  var hasErrors = useMemo(function () {
    return Object.values(statuses).some(function (status) {
      return !!status.error;
    });
  }, [statuses]);
  var canUpdateMore = useMemo(function () {
    return !hasFinished || hasErrors;
  }, [hasFinished, hasErrors]);

  function startUpdating() {
    return _startUpdating.apply(this, arguments);
  }

  function _startUpdating() {
    _startUpdating = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setDeleting(true);
              _context.next = 3;
              return Promise.all(itemsToProcess.map(function (item) {
                return updateItem(item);
              }));

            case 3:
              setDeleting(false);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _startUpdating.apply(this, arguments);
  }

  function updateItem(_x) {
    return _updateItem.apply(this, arguments);
  }

  function _updateItem() {
    _updateItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(item) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatchStatus({
                type: 'addOne',
                key: item.id,
                value: {
                  progress: 50,
                  active: true
                }
              });
              _context2.prev = 1;
              _context2.next = 4;
              return updateTaskState(item.id, props.newState);

            case 4:
              dispatchStatus({
                type: 'addOne',
                key: item.id,
                value: {
                  progress: 100,
                  active: true,
                  finished: true,
                  success: true
                }
              });
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);
              dispatchStatus({
                type: 'addOne',
                key: item.id,
                value: {
                  progress: 50,
                  active: true,
                  finished: true,
                  error: true
                }
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 7]]);
    }));
    return _updateItem.apply(this, arguments);
  }

  useEffect(function () {
    if (props.isVisible) {
      var decoratedTasks = props.tasks.map(function (task) {
        return _objectSpread(_objectSpread({}, task), {}, {
          canChangeState: taskCanChangeState(task, props.newState)
        });
      });
      setTasks(decoratedTasks);
      var newStatuses = {};

      var _iterator2 = _createForOfIteratorHelper(decoratedTasks),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          newStatuses[item === null || item === void 0 ? void 0 : item.id] = {
            progress: 0,
            finished: item.canChangeState ? undefined : true
          };
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      dispatchStatus({
        type: 'addMany',
        items: newStatuses,
        clear: true
      });
    }
  }, [props.isVisible]);
  return /*#__PURE__*/_jsxs(Container, {
    title: t("tasks.multiple.state.title", {
      quantity: tasks.length,
      state: t("tasks.state.".concat(props.newState))
    }),
    open: props.isVisible,
    onCancel: function onCancel() {
      return !isDeleting && props.onCancel();
    },
    closable: !isDeleting,
    footer: [/*#__PURE__*/_jsx(Button, {
      type: "text",
      onClick: function onClick() {
        return !isDeleting && props.onCancel();
      },
      disabled: isDeleting,
      children: t('close')
    }, "cancel"), canUpdateMore && /*#__PURE__*/_jsx(Button, {
      type: "primary",
      onClick: startUpdating,
      disabled: isDeleting,
      children: t("tasks.multiple.state.cta", {
        quantity: isDeleting ? tasks.length : itemsToProcess.length
      })
    }, "submit")],
    children: [!hasFinished && hasTasksThatCantChange && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Alert, {
        message: t('warning'),
        description: t("tasks.multiple.state.warning"),
        type: "warning",
        showIcon: true
      }), /*#__PURE__*/_jsx("br", {})]
    }), !hasFinished && /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsxs(Trans, {
        i18nKey: "tasks.multiple.state.info",
        values: {
          quantity: itemsToProcess.length,
          state: t("tasks.state.".concat(props.newState))
        },
        children: ["1", /*#__PURE__*/_jsx("strong", {
          children: "2"
        }), /*#__PURE__*/_jsx("span", {
          className: "state-icon state-".concat(props.newState),
          children: "3"
        })]
      })
    }), /*#__PURE__*/_jsx(List, {
      bordered: true,
      dataSource: tasks,
      renderItem: function renderItem(item) {
        return /*#__PURE__*/_jsx(ListItem, {
          task: item,
          newState: props.newState,
          status: statuses[item.id]
        }, item.id);
      }
    }), hasFinished && /*#__PURE__*/_jsx(Result, {
      status: hasErrors ? 'error' : 'success',
      title: hasErrors ? t("tasks.multiple.state.error") : t("tasks.multiple.state.success"),
      subTitle: hasErrors && t('unknownError')
    })]
  });
};

var ListItem = function ListItem(_ref) {
  var _status$progress;

  var task = _ref.task,
      newState = _ref.newState,
      status = _ref.status;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  var progressStatus = useMemo(function () {
    if (status !== null && status !== void 0 && status.error) {
      return 'exception';
    }

    if (status !== null && status !== void 0 && status.success) {
      return 'success';
    }
  }, [status]);
  return /*#__PURE__*/_jsxs(List.Item, {
    className: "list-item ".concat(classes({
      unavailable: !task.canChangeState
    }), " "),
    children: [/*#__PURE__*/_jsx("span", {
      className: "state-dot state-".concat(task.state)
    }), /*#__PURE__*/_jsx("span", {
      className: "title",
      children: /*#__PURE__*/_jsx(TaskReferenceView, {
        task: task
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "states",
      children: [/*#__PURE__*/_jsx(Tooltip, {
        title: t("tasks.state.".concat(task.state)),
        children: /*#__PURE__*/_jsx("div", {
          className: "state-icon state-".concat(task.state),
          children: TaskStateIcon[task.state]
        })
      }), /*#__PURE__*/_jsxs("span", {
        className: "arrow-icon",
        children: [task.canChangeState && /*#__PURE__*/_jsx(ArrowRightOutlined, {}), !task.canChangeState && /*#__PURE__*/_jsx(CloseOutlined, {})]
      }), /*#__PURE__*/_jsx(Tooltip, {
        title: t("tasks.state.".concat(newState)),
        children: /*#__PURE__*/_jsx("div", {
          className: "state-icon state-".concat(newState),
          children: TaskStateIcon[newState]
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "progress-container",
      children: task.canChangeState && /*#__PURE__*/_jsx(Progress, {
        type: "circle",
        percent: (_status$progress = status === null || status === void 0 ? void 0 : status.progress) !== null && _status$progress !== void 0 ? _status$progress : 0,
        width: 24,
        showInfo: !!(status !== null && status !== void 0 && status.active),
        status: progressStatus
      })
    })]
  });
};

var Container = styled(Modal).withConfig({
  displayName: "ChangeStateModal__Container",
  componentId: "sc-hst9se-0"
})([".item-row{width:100%;}.ant-list-item{display:flex;align-items:center;justify-content:flex-start;.state-dot{display:inline-block;width:12px;height:12px;margin-right:12px;border-radius:50%;", "}.title{flex:1;}.states{display:flex;align-items:center;width:60px;justify-content:space-between;}.progress-container{margin-left:15px;width:25px;}&.unavailable{.title{text-decoration:line-through;}> *{opacity:0.25;}}}.state-icon{", "}"], Object.values(TaskState).map(function (state) {
  return css(["&.state-", "{background:", ";}"], state, TaskStateColor[state]);
}), Object.values(TaskState).map(function (state) {
  return css(["&.state-", "{color:", ";.anticon,.label{color:", ";}}"], state, TaskStateColorDark[state], TaskStateColorDark[state]);
}));